import { useEffect, useRef } from 'react';
import lottie from 'lottie-web';
const useSvgLoad = (src: string, load: boolean = false, svgRef: any, onComplete: any = null) => {
  const lotRef: any = useRef();

  useEffect(() => {
    if (load) {
      if (src) {
        const lottieOpts: any = {
          container: svgRef.current as any,
          renderer: 'svg',
          loop: false,
          autoplay: false,
          path: src,
        };
        let lot: any = lotRef.current;
        if (!lot) {
          lot = lottie.loadAnimation(lottieOpts);
          lot.onComplete = (e: any) => {
            if (onComplete) onComplete(e);
          };
          lotRef.current = lot;
        }
      }
    }
  }, [src, load, svgRef, lotRef]);
};

export default useSvgLoad;
